import { useConfig } from '@genflow/core';
import axios from 'axios';
import { get } from 'lodash';

const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export default (resetRedirectUri, debug) => {
    const { vendorUuid, staging, production } = useConfig();
    const { forgotPassword } = IS_DEV ? staging : production;

    const sendResetEmail = async (email) => {
        const response = await axios({
            method: 'post',
            url: `${forgotPassword}/reset-account-password`,
            data: {
                resetRedirectUri, // e.g. https://hardbody.store/reset-password?code=
                username: `${email.toLowerCase()}#${vendorUuid}`,
            },
        });

        if (debug) {
            console.log('useForgotPassword sendResetEmail response: ', response);
        }

        return {
            success: response.status === 200,
            response,
        };
    };

    const resetPassword = async (resetCode, password) => {
        const response = await axios({
            method: 'post',
            url: `${forgotPassword}/reset-account-password`,
            data: {
                resetCode,
                password,
            },
        });

        if (debug) {
            console.log('useForgotPassword resetPassword response: ', response);
        }

        const isCodeExpired = get(response, 'data.message', '').includes('This link has now expired.');

        return {
            success: response.status === 200,
            isCodeExpired,
            response,
        };
    };

    return {
        sendResetEmail,
        resetPassword,
    };
};
